import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { ApplicationClientCommonModule, ServiceResponseModule } from '@sdbn/common';

import { CommonTranslationModule } from '@sdbn/common';
import { TMCTableModule } from '@sdbn/common';
import { TransportInfoPanelModule } from '@sdbn/common';
import { LinkTransportsDialogComponent } from './component/link-transports-dialog.component';

import { MatTooltipModule as MatTooltipModule } from '@angular/material/tooltip';
import { MatRadioModule as MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule as MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';

@NgModule({
  declarations: [
    LinkTransportsDialogComponent
  ],
  imports: [
    CommonModule,

    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    TransportInfoPanelModule,
    TMCTableModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    ServiceResponseModule,
    MatTooltipModule,
    MatRadioModule,
    MatInputModule,
    MatCheckboxModule,
    MatFormFieldModule
  ],

})
export class LinkTransportsModule { }
